// Les modèles présentés sur le site, dans l'ordre du showroom : toute la gamme
// 2026 de harley-davidson.com/fr, avec ses familles et dans son ordre. Seule
// différence : les CVO, que le site officiel range en Grand American Touring,
// ont leur onglet (sinon huit modèles sur deux lignes) ; le CVO trike reste en Trike.
// Les textes résument les fiches officielles : ne rien y ajouter qui n'y soit pas.
// Les chiffres (prix, moteur, puissance…) et les vues 360° ne sont pas saisis ici :
// ils sont récupérés sur harley-davidson.com par `bun tools/fetch-models.js`,
// qui écrit src/data/hd-2026.json. Pour ajouter un modèle, ajoutez une ligne
// avec son identifiant d'URL (harley-davidson.com/fr/fr/motorcycles/<id>.html)
// puis relancez ce script et tools/make-masks.py.

export const FAMILIES = [
  { id: "sport", label: "Sport" },
  { id: "cruiser", label: "Cruiser" },
  { id: "touring", label: "Grand American Touring" },
  { id: "cvo", label: "CVO" },
  { id: "adventure", label: "Adventure Touring" },
  { id: "trike", label: "Trike" },
];

export const LINEUP = [
  {
    id: "nightster",
    family: "sport",
    text: "Le roadster le plus accessible de la gamme : position droite, selle basse et bicylindre Revolution Max refroidi par liquide. Une porte d'entrée idéale pour découvrir Harley-Davidson.",
  },
  {
    id: "nightster-special",
    family: "sport",
    text: "La Nightster plus sombre et mieux équipée : guidon surélevé, écran couleur TFT de 102 mm et place passager repliable, avec le Revolution Max 975T de 89 ch.",
  },
  {
    id: "sportster-s",
    family: "sport",
    text: "Un muscle bike au gros pneu avant, propulsé par le Revolution Max 1250T. Le plus sportif des Sportster, pensé pour les sorties nerveuses.",
  },
  {
    id: "street-bob",
    family: "cruiser",
    text: "Le bobber dépouillé par excellence : guidon mini-ape, selle solo et Milwaukee-Eight 117. Une base parfaite pour la customisation.",
  },
  {
    id: "low-rider-s",
    family: "cruiser",
    text: "Le cruiser performance de la famille : Milwaukee-Eight 117 High Output, fourche inversée et 145 mm de garde au sol pour enrouler les virages.",
  },
  {
    id: "low-rider-st",
    family: "cruiser",
    text: "Un cruiser taillé pour la route, dans le style custom West Coast : carénage léger inspiré de la FXRT fixé au cadre, sacoches, échappement 2-en-1 et Milwaukee-Eight 117 High Output.",
  },
  {
    id: "heritage-classic",
    family: "cruiser",
    text: "Le style des années 50 avec le confort d'une machine de voyage : sacoches étanches et verrouillables, pare-brise amovible et position détendue.",
  },
  {
    id: "fat-boy",
    family: "cruiser",
    text: "Une icône depuis 1990 : roues pleines Lakester, pneus larges et chrome à profusion. Le cruiser massif par excellence.",
  },
  {
    id: "breakout",
    family: "cruiser",
    text: "Un drag bike au long empattement, roue arrière de 240 mm et fourche inclinée. Bas, long et taillé pour être vu.",
  },
  {
    id: "street-glide",
    family: "touring",
    text: "La référence du bagger : carénage « batwing » fixé à la fourche, sacoches rigides et écran tactile. Faite pour avaler les kilomètres.",
  },
  {
    id: "road-glide",
    family: "touring",
    text: "Le carénage « Sharknose » fixé au cadre pour une direction légère et une protection au vent remarquable sur les longs trajets.",
  },
  {
    id: "street-glide-limited",
    family: "touring",
    text: "La Street Glide équipée pour le grand tourisme : coffre Grand Tour-Pak, selles pilote et passager chauffantes, Milwaukee-Eight VVT 117 et système Skyline OS avec navigation et commande vocale.",
  },
  {
    id: "road-glide-limited",
    family: "touring",
    text: "Le carénage Sharknose avec tout le confort du duo : coffre Grand Tour-Pak, selles et poignées chauffantes, pare-brise haut et navigation Skyline OS, avec le Milwaukee-Eight 117.",
  },
  {
    id: "cvo-street-glide-st",
    family: "cvo",
    text: "La Street Glide préparée pour la performance : Milwaukee-Eight 121 High Output, fourche inversée réglable, amortisseurs à réservoir séparé et guidon Fused plus large et plus haut.",
  },
  {
    id: "cvo-road-glide-st",
    family: "cvo",
    text: "Le bagger de course : Milwaukee-Eight 121 High Output, suspensions avant et arrière réglables, détails en carbone forgé et carénage Sharknose au pare-brise teinté rouge.",
  },
  {
    id: "cvo-street-glide-limited",
    family: "cvo",
    text: "Le luxe CVO pour le grand voyage : peintures exclusives, commandes de la Collection Carbide, Tour-Pak à éclairage LED intégré et Milwaukee-Eight VVT 121.",
  },
  {
    id: "cvo-street-glide",
    family: "cvo",
    text: "Le bagger CVO dans son coloris exclusif Torched Orange Tri-Tone, avec le Milwaukee-Eight VVT 121, des suspensions arrière haut de gamme et le système audio Harley-Davidson.",
  },
  {
    id: "pan-america-1250-st",
    family: "adventure",
    short: "Pan America ST", // nom géant du showroom
    text: "La Pan America tournée vers la route : roues de 432 mm (17 pouces), suspensions réglables abaissées, quickshifter Screamin' Eagle et pare-brise bas et fumé.",
  },
  {
    id: "pan-america-1250-special",
    family: "adventure",
    short: "Pan America Special",
    text: "Le trail de Harley-Davidson, à l'aise sur route comme sur piste, avec le Revolution Max 1250 et des suspensions semi-actives.",
  },
  {
    id: "pan-america-1250-limited",
    family: "adventure",
    short: "Pan America Limited",
    text: "La Pan America équipée dès l'usine pour le grand voyage : bagagerie rigide en aluminium de 120 litres, hauteur de selle adaptative, quickshifter, protections et éclairage auxiliaire.",
  },
  {
    id: "road-glide-3",
    family: "trike",
    text: "Un trike au style hot rod : carénage Sharknose, Milwaukee-Eight 117 et suspensions arrière repensées qui doublent le débattement, pour un pilotage plus souple sur trois roues.",
  },
  {
    id: "street-glide-3-limited",
    family: "trike",
    text: "Le grand tourisme sur trois roues : carénage Batwing, coffre Grand Tour-Pak avec haut-parleurs, selles chauffantes et Milwaukee-Eight VVT 117, sur des suspensions arrière repensées.",
  },
  {
    id: "cvo-street-glide-3-limited",
    family: "trike",
    text: "Le trike en version CVO : peintures et finitions exclusives, accessoires de la Collection Carbide, selles chauffantes, Tour-Pak et Milwaukee-Eight 121.",
  },
];
